"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var CreateUnit_vue_1 = __importDefault(require("./CreateUnit.vue"));
var VSearchInput_vue_1 = __importDefault(require("../scraps/VSearchInput.vue"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var event_bus_1 = require("../../event-bus");
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
exports.default = vue_1.default.extend({
    name: "top-menu",
    components: {
        CreateUnit: CreateUnit_vue_1.default,
        DistrictSelect: DistrictSelect_vue_1.default,
        VSearchInput: VSearchInput_vue_1.default
    },
    props: {
        districts: {
            type: Array,
            required: true
        },
        currentDistrict: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            permissions: permissions_json_1.default,
            search: ""
        };
    },
    computed: {
        displayDistrictSelect: function () {
            return (this.districts.length > 1);
        }
    },
    methods: {
        onSearchInputEnter: function () {
            event_bus_1.EventBus.$emit(event_bus_1.events.common.search.hit);
        },
        onCurrentDistrictChange: function (option) {
            event_bus_1.EventBus.$emit(event_bus_1.events.district.change, {
                id: option.value,
                name: option.name
            });
        }
    }
});
